export default "__VITE_ASSET__iwgF7Ve5__"